import { h } from 'preact';

import style from './style.css';
import util from '../../lib/util';

function CategoryNav(props) {
    const { productStore, categoryStore, brandStore } = props.stores;
    const { queryFilter, total, view } = productStore;
    const { brands } = brandStore;

    return (
        <div>
            <small class='text-muted font-weight-lighter float-right mr-2'>
                Total: {total}<br />
            </small>

            <div class='btn-group mr-2' role='group'>
                <button id='btnGroupBrand' type='button' class={`btn btn-sm btn-${queryFilter.brand ? 'success' : 'outline-secondary'} dropdown-toggle`}
                    data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'
                    onClick={() => productStore.toggleView('brands')}
                >
                    Brands: {queryFilter.brand ? queryFilter.brand : 'All'}
                </button>
                <div class={`dropdown-menu ${view.brands ? 'show' : 'hide'}`} aria-labelledby='btnGroupBrand'>
                    {brands.map(brand => (
                        <div class={`dropdown-item ${style.pointerCursor}`}
                            onClick={() => {
                                categoryStore.toggleQueryfilter('brand', brand.brandno, { setValue: true, toggle: () => categoryStore.toggleView('brands') });
                                productStore.toggleQueryfilter('mainCat', '', { setValue: 1, skipUpdate: 1 });
                                productStore.toggleQueryfilter('intCat', '', { setValue: 1, skipUpdate: 1 });
                                productStore.toggleQueryfilter('subCat', '', { setValue: 1, skipUpdate: 1 });
                                productStore.toggleQueryfilter('brand', brand.brandno, { setValue: true, toggle: () => productStore.toggleView('brands') });
                            }}
                        >{brand.name}</div>
                    ))}
                </div>
            </div>

            <div class='btn-group mr-2' role='group'>
                <button id='btnGroupTranslationsImproved' type='button' class={`btn btn-sm btn-${queryFilter.translationsImproved ? 'success' : 'outline-secondary'} dropdown-toggle`}
                    data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'
                    onClick={() => productStore.toggleView('translationsImproved')}
                >
                    Improved translations: {queryFilter.translationsImproved ? queryFilter.translationsImproved : 'None'}
                </button>
                <div class={`dropdown-menu ${view.translationsImproved ? 'show' : 'hide'}`} aria-labelledby='btnGroupTranslationsImproved'>
                    <div class={`dropdown-item ${style.pointerCursor}`} 
                        onClick={() => productStore.toggleQueryfilter('translationsImproved', '', { setValue: true, toggle: () => productStore.toggleView('translationsImproved') })}
                    >Clear</div>
                    {['de', 'en', 'fr', 'it', 'no'].map(el => (
                        <div class={`dropdown-item ${style.pointerCursor}`}
                            onClick={() => productStore.toggleQueryfilter('translationsImproved', el, {
                                setValue: true, toggle: () => productStore.toggleView('translationsImproved'),
                            })}>{el}</div>
                    ))}
                </div>
            </div>

            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.showOnConsumerWeb)}`}
                onClick={() => productStore.toggleQueryfilter('showOnConsumerWeb', util.cyclevalues(queryFilter.showOnConsumerWeb, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.showOnConsumerWeb ? 'on' : 'off'} mr-1`} />
                CW
            </button>
            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.showonwebyesno)}`}
                onClick={() => productStore.toggleQueryfilter('showonwebyesno', util.cyclevalues(queryFilter.showonwebyesno, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.showonwebyesno ? 'on' : 'off'} mr-1`} />
                DW
            </button>
            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.isNew)}`}
                onClick={() => productStore.toggleQueryfilter('isNew', util.cyclevalues(queryFilter.isNew, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.isNew ? 'on' : 'off'} mr-1`} />
                New
            </button>

            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.preSale)}`}
                onClick={() => productStore.toggleQueryfilter('preSale', util.cyclevalues(queryFilter.preSale, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.preSale ? 'on' : 'off'} mr-1`} />
                PS
            </button>
            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.preSaleNew)}`}
                onClick={() => productStore.toggleQueryfilter('preSaleNew', util.cyclevalues(queryFilter.preSaleNew, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.preSaleNew ? 'on' : 'off'} mr-1`} />
                PS New
            </button>

            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.hasDescription)}`}
                onClick={() => productStore.toggleQueryfilter('hasDescription', util.cyclevalues(queryFilter.hasDescription, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.hasDescription ? 'on' : 'off'} mr-1`} />
                Has desc
            </button>
            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.hasFeatures)}`}
                onClick={() => productStore.toggleQueryfilter('hasFeatures', util.cyclevalues(queryFilter.hasFeatures, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.hasFeatures ? 'on' : 'off'} mr-1`} />
                Has feat
            </button>
            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.hasTech)}`}
                onClick={() => productStore.toggleQueryfilter('hasTech', util.cyclevalues(queryFilter.hasTech, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.hasTech ? 'on' : 'off'} mr-1`} />
                Has tech
            </button>
            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.hasCare)}`}
                onClick={() => productStore.toggleQueryfilter('hasCare', util.cyclevalues(queryFilter.hasCare, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.hasCare ? 'on' : 'off'} mr-1`} />
                Has care
            </button>
            <button class={`mr-2 btn btn-sm ${util.buttonClass(queryFilter.hasHowtouse)}`}
                onClick={() => productStore.toggleQueryfilter('hasHowtouse', util.cyclevalues(queryFilter.hasHowtouse, [null, 1, 0]), { setValue: 1 })}
            >
                <i class={`fas fa-toggle-${queryFilter.hasHowtouse ? 'on' : 'off'} mr-1`} />
                Has howto
            </button>

            <button class={`mr-2 btn btn-sm ${queryFilter.ratings ? 'btn-success' : 'btn-outline-secondary'}`}
                onClick={() => productStore.toggleQueryfilter('ratings')}
            >
                <i class={`fas fa-toggle-${queryFilter.ratings ? 'on' : 'off'} mr-1`} />
                Has ratings
            </button>
            <button class={`mr-2 btn btn-sm ${queryFilter.showall ? 'btn-success' : 'btn-outline-secondary'}`}
                onClick={() => productStore.toggleQueryfilter('showall')}
            >
                <i class={`fas fa-toggle-${queryFilter.showall ? 'on' : 'off'} mr-1`} />
                Show all
            </button>

            <span class='float-left form-row align-items-center mr-5'>
                <div class='col-auto'>
                    <input type='text' class='form-control form-control-sm' id='inlineFormInputName' placeholder='Search for products...'
                        onInput={e => productStore.toggleQueryfilter('search', e.target.value, { setValue: true, skipUpdate: true, setTimer: true })}
                        value={queryFilter.search}
                    />
                </div>
                <div class='col-auto'>
                    <button type='button' class='btn btn-sm btn-primary' onClick={() => productStore.list()}>Search</button>
                </div>
            </span>
        </div>
    );
}

export default CategoryNav;


// WEBPACK FOOTER //
// ./components/products/nav.js